module.exports = __webpack_public_path__ + "img/role-shadow.c88fb189.png";